import { render, staticRenderFns } from "./TasksDetailsRequestSection.vue?vue&type=template&id=30634fd5&scoped=true&"
import script from "./TasksDetailsRequestSection.vue?vue&type=script&lang=js&"
export * from "./TasksDetailsRequestSection.vue?vue&type=script&lang=js&"
import style0 from "./TasksDetailsRequestSection.vue?vue&type=style&index=0&id=30634fd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30634fd5",
  null
  
)

export default component.exports